import {
  SbeServiceClient
} from "@/proto/sbe_grpc_web_pb";
import { 
  Sbe, 
  ListSbeRequest,
  ItemSbeRequest,
  SbeFilter,
  SbeSort,
  SbePagination,
  CreateSbeRequest,  
  UpdateSbeRequest, 
  DeleteSbeRequest
} from "@/proto/sbe_pb";
import {handleRefreshToken} from '@/main'

// Количество на странице по-умолчанию
const defaultLimit:number = 100;

export class SbeApi {
  items: Array<Sbe> = [];
  client: SbeServiceClient;

  constructor() {
    const host:string = (window as any).VUE_APP_API_URL ?? '';
    this.client = new SbeServiceClient(host, null, null);
  }

  getAuth(){
    const metadata: any = {
      Authorization: localStorage.getItem('accessToken')
    }
    return metadata
  }

  // Установка и получение фильтров
  createFilter(data: any){

    const filter = new SbeFilter();
    const sbeId:number = data.sbeId !== undefined ? parseInt(data.sbeId) : 0;
    const sbeName:string = data.sbeName !== undefined ? data.sbeName.toString() : "";
    const sbeFullname:string = data.sbeFullname !== undefined ? data.sbeFullname.toString() : "";

    // Устанавливаем фильтры
    filter.setSbeId(sbeId);
    filter.setSbeName(sbeName);
    filter.setSbeFullname(sbeFullname);

    return filter;
  }

  // Установка и получение сортировки
  createSort(data: any){

    const sort = new SbeSort();
    const name:string = data.name !== undefined ? data.name.toString() : "sbe_name";
    const exp:string = data.exp !== undefined ? data.exp.toString() : "asc";

    // Устанавливаем параметры сортировки
    sort.setName(name);
    sort.setExp(exp);

    return sort;
  }

  // Установка и получение пагинации
  createPagination(data: any){

    const pagination = new SbePagination();
    const page:number = data.page !== undefined ? Number(data.page) : 1;
    const limit:number = data.limit !== undefined ? Number(data.limit) : defaultLimit;

    // Устанавливаем пагинацию
    pagination.setPage(page);
    pagination.setLimit(limit);
    pagination.setPages(0);

    return pagination;
  }

  // Список элементов
  getSbeItems(filter: any, sort: any, pagination: any){

    const request = new ListSbeRequest();
    
    // Устанавливаем параметры запроса
    request.setFilter(this.createFilter(filter));
    request.setSort(this.createSort(sort));
    request.setPagination(this.createPagination(pagination));

    return new Promise((resolve, reject) => {
      this.client.listSbe(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err)
        } else {
          resolve(message.getItemsList());
        }
      });
    });
  }

  // Получение элемента
  getSbeItem(filter: any){

    const request = new ItemSbeRequest();

    // Устанавливаем параметры запроса
    request.setFilter(this.createFilter(filter));

    return new Promise((resolve, reject) => {
      this.client.itemSbe(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err)
        } else {
          resolve(message.getItem());
        }
      });
    });
  }

  // Создание элемента
  createSbeItem(data: any){

    const request = new CreateSbeRequest();
    request.setSbeId(data.sbeId);
    request.setSbeName(data.sbeName);
    request.setSbeFullname(data.sbeFullame);

    return new Promise((resolve, reject) => {
      this.client.createSbe(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err)
        } else {
          resolve(message);
        }
      });
    });
  }

  // Редактирование элемента
  updateSbeItem(data: any){

    const request = new UpdateSbeRequest();
    request.setSbeId(data.sbeId);
    request.setSbeName(data.sbeName);
    request.setSbeFullname(data.sbeFullame);

    return new Promise((resolve, reject) => {
      this.client.updateSbe(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err);
        } else {
          resolve(message);
        }
      });
    });
  }

  // Удаление элемента
  deleteSbeItem(data: any){

    const request = new DeleteSbeRequest();
    request.setSbeId(data.sbeId);

    return new Promise((resolve, reject) => {
      this.client.deleteSbe(request, this.getAuth(), (err, message) => {
        if (err) {
          handleRefreshToken()
          reject(err);
        } else {
          resolve(message);
        }
      });
    });
  }
}